'use client';

import { useEffect } from 'react';
import { captureFirstTouchUTM } from '@/lib/utm-tracker';

interface UTMTrackerProviderProps {
  children: React.ReactNode;
}

/**
 * Provider global que captura UTMs da URL ao montar
 * Deve ser adicionado no layout root (app/layout.tsx)
 */
export function UTMTrackerProvider({ children }: UTMTrackerProviderProps) {
  useEffect(() => {
    // Capturar UTMs na primeira renderização
    captureFirstTouchUTM();
  }, []);

  return <>{children}</>;
}
